export function track(eventName: string, eventOptions?: object) {
  if (
    typeof eventName !== 'undefined' &&
    typeof window !== 'undefined' &&
    typeof (window as any).gtag !== 'undefined'
  ) {
    (window as any).gtag('event', eventName, eventOptions);
  }
}
